import React from "react";
import { motion } from "framer-motion";

// Section heading with overline, serif title, and optional subtitle
export default function SectionHeading({ overline, title, subtitle, align = "left", className = "" }) {
  const isCenter = align === "center";
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className={`max-w-3xl ${isCenter ? "mx-auto text-center" : ""} ${className}`}
    >
      {overline && <div className="overline mb-5">{overline}</div>}
      <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-foreground text-balance">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl">
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}
